































































import EventBus from '@/plugins/EventBus'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '../../RegrasDeCalculo/Store/RegrasDeCalculoStore'

@Component
export default class ModalAddHospitalRegraGarantiaMinima extends Vue {
  loadAddHospital: boolean = false
  get loadingAddHospital() { return this.loadAddHospital }
  set loadingAddHospital(value: boolean) { this.loadAddHospital = value }

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get showModal() {
    return this.getRegrasDeCalculoStore.modal.regraGarantiaMinimaAddHospital
  }

  set showModal(value: boolean) {
    this.getRegrasDeCalculoStore.setModal({ name: 'regraGarantiaMinimaAddHospital', value })
  }

  get hospitais() {
    return this.getRegrasDeCalculoStore.fontesPagadoras
  }

  get hospital() {
    return this.getRegrasDeCalculoStore.hospitalGarantiaMinimaGlobal
  }

  set hospital(value: any) {
    this.getRegrasDeCalculoStore.setHospitalGarantiaMinimaGlobal(value)
  }

  async addHospital() {
    this.loadingAddHospital = true
    const response = await this.getRegrasDeCalculoStore.addHospitalGarantiaMinimaGlobal()
    if (!response.success) {
      this.loadingAddHospital = false
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao adicionar o hospital.', icon: 'warning', color: '#C62828' })
      return
    }
    EventBus.$emit('setSnackbar', { show: true, text: 'Hospital adicionado com sucesso!', icon: 'done', color: '#2E7D32' })
    this.showModal = false
    this.loadingAddHospital = false
  }

  @Watch('showModal')
  onShowModalChange(value: boolean) {
    if (!value) {
      this.hospital = null
    }
  }
}
